/**
 * Site Header Module
 * Handles scroll detection and adds 'is-scrolled' class to body
 */

const handleScroll = () => {
	const scrollY = window.scrollY || window.pageYOffset;
	const body = document.body;

	if (scrollY > 100) {
		body.classList.add('is-scrolled');
	} else {
		body.classList.remove('is-scrolled');
	}
};

// Throttle scroll events for better performance
let ticking = false;
const onScroll = () => {
	if (!ticking) {
		window.requestAnimationFrame(() => {
			handleScroll();
			ticking = false;
		});
		ticking = true;
	}
};

// Check initial scroll position
handleScroll();

// Listen for scroll events
window.addEventListener('scroll', onScroll, { passive: true });

